// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"f4ce560fbbedd618f246","883":"d95bf690f09e2bf5d3f8"}[chunkId] + ".js";
};